import {
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_ERROR_MESSAGE,
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_FILE,
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_NUMBER,
  JOB_BOARD_PURCHASE_ORDER_POPUP_SET_STEP, JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP,
} from "../../../constants/actionTypes";


export const PURCHASE_ORDER_CONTENT = {
  purchaseOrder: 0,
  purchaseOrderSuccess: 1,
  purchaseOrderError: 2,
  purchaseOrderInvoice: 100,
  purchaseOrderInvoiceSuccess: 101,
  purchaseOrderInvoiceError: 102,
  purchaseOrderPay: 200,
  purchaseOrderPaySuccess: 201,
  purchaseOrderPayError: 202,
}

const initialState = {
  purchaseOrderStep: 0,
  purchaseOrderInvoiceNumber: "",
  purchaseOrderInvoiceFile: null,
  purchaseOrderErrorMessage: "",
};

export default function jobPaymentState(state = initialState, action) {
  switch(action.type) {
    case JOB_BOARD_PURCHASE_ORDER_POPUP_SET_STEP:
    case JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_NUMBER:
    case JOB_BOARD_PURCHASE_ORDER_POPUP_SET_INVOICE_FILE:
    case JOB_BOARD_PURCHASE_ORDER_POPUP_SET_ERROR_MESSAGE:
      return {...state, ...action.payload};
    case JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP:
      return {
        ...state,
        purchaseOrderStep: action.payload.purchaseOrderStep || 0,
        purchaseOrderInvoiceNumber: "",
        purchaseOrderInvoiceFile: null,
        purchaseOrderErrorMessage: "",
      };
    default:
      return state;
  }
}
